import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";

import { CONTACT_EMAIL } from "@/components/aziende/plans";

export const UniscitiCta = () => (
  <section className="relative px-6 py-24 lg:py-44" data-testid="istituti-unisciti-section">
    <Reveal className="max-w-5xl mx-auto text-center">
      <Eyebrow className="mb-8">Unisciti a Prodigy</Eyebrow>
      <p className="mx-auto max-w-[60ch] text-lg sm:text-xl leading-relaxed text-titanium" data-testid="istituti-unisciti-text">
        Crediamo in un rapporto trasparente, costruito passo dopo passo insieme alla vostra scuola. Vi invitiamo a un{" "}
        <span className="text-white font-medium">incontro conoscitivo</span> per mostrarvi la piattaforma dal vivo e
        rispondere a ogni domanda. Le adesioni sono aperte per i primi Istituti partner.
      </p>
    </Reveal>
    <Reveal className="max-w-5xl mx-auto text-center mt-24 lg:mt-36">
      <h2 className="font-extrabold tracking-[-0.045em] leading-[1.02] text-4xl sm:text-6xl lg:text-7xl" data-testid="istituti-final-title">
        Per Prodigy la Fiducia <span className="text-titanium">non è negoziabile.</span>
      </h2>
      <div className="mt-14 flex flex-col items-center gap-4">
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="cta cta-glow glass group inline-flex items-center justify-center gap-3 rounded-full px-10 py-4 text-sm sm:text-base font-semibold text-white"
          data-testid="istituti-cta-contatti"
        >
          Contattaci
          <ArrowRight className="h-4 w-4 text-cyan transition-transform duration-300 group-hover:translate-x-1" />
        </a>
        <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link text-sm text-titanium" data-testid="istituti-cta-email">
          {CONTACT_EMAIL}
        </a>
      </div>
    </Reveal>
  </section>
);
